module.exports = __webpack_public_path__ + "img/9.68f6697f.png";